<template>
    <div>
        <div  v-if="dataStatus !== 'email_verification'">
            <b-alert class="text-center" show variant="warning">
                {{Core.Definition.getDefinition('Veuillez indiquer un courriel valide. Un lien de confirmation sera envoyé à votre adresse courriel. Important: Vous devez confirmer votre courriel pour vous connecter à votre compte.')}}
            </b-alert>
            <DynamicForm
                    ref="dynamicForm"
                    getRoot="/user/register"
                    saveRoot="/user/register"
                    :options="{
                    submit: {
                        text: Core.Definition.getDefinition('Créer un compte'),
                        variant: 'primary'
               }}"
                    @onRequestSuccess="onRequestSuccess"
                    :formStructure="dataFormStructures.createAccount">
                <slot slot="beforeFormButtons">
                    <slot name="beforeFormButtons"></slot>
                </slot>
            </DynamicForm>
        </div>
        <div v-if="dataStatus === 'email_verification'">
            <b-alert class="text-center " show variant="warning">
                <div class="size-fullscreen h1 animated fadeIn"><i class="fa fa-check-circle"></i></div>
                {{Core.Definition.getDefinition('Merci pour votre inscription! Un lien de confirmation à été envoyé à votre adresse courriel. Vous pouvez vous connecter à votre compte mais vous devez confirmer votre courriel pour vos prochaines réservations.')}}
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" @click="onLoginClick" class="btn">{{Core.Definition.getDefinition('Connexion')}}</b-button>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue'
    import DynamicForm from './DynamicForm'
    export default {
        name: 'CreateAccount',
        components: {
            DynamicForm
        },
        props: {
        },
        computed: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataStatus: '',
                dataFormStructures: {
                    createAccount: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'firstname'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'lastname'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'email'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'birthdate'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'phone'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'password'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'confirmPassword'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'firstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'lastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'email',
                                type: 'email',
                                required: true,
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'birthdate',
                                type: Core.Value.typeDatePicker,
                                required: false,
                                label: Core.Definition.getDefinition('Date de naissance'),
                                value: null,
                                onChange() {}
                            },
                            {
                                id: 'phone',
                                type: 'phone',
                                required: true,
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'password',
                                type: 'password',
                                required: true,
                                label: Core.Definition.getDefinition('Mot de passe'),
                                value: ''
                            },
                            {
                                id: 'confirmPassword',
                                type: 'password',
                                required: true,
                                label: Core.Definition.getDefinition('Confirmation du mot de passe'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data) {
                if(data.status !== undefined) {
                    this.dataStatus = data.status
                    this.$emit('onCreateAccount', this.dataStatus)
                }
            },
            onLoginClick() {
                this.$emit('onLoginClick', this.dataStatus)
            }
        }
    }
</script>
